import { Sidenav } from '@circlefin/components'
import { usePermission } from '@circlefin/permissions/react'
import { isPartOfSection } from '@services/sections'
import { lineOfCreditSection } from '@services/sections/lib/lineOfCredit'
import { settlementAdvanceSection } from '@services/sections/lib/settlementAdvance'
import {
  SettlementCreditLineType,
  useSettlementCreditLinesQuery,
} from '@shared/graphql'
import Link from 'next/link'
import { useRouter } from 'next/router'
import useTranslation from 'next-translate/useTranslation'

import type { Section } from '@services/sections/types'

const sectionMap: Record<SettlementCreditLineType, Section> = {
  [SettlementCreditLineType.lineOfCredit]: lineOfCreditSection,
  [SettlementCreditLineType.settlementAdvance]: settlementAdvanceSection,
}

export const CreditNavItem: React.FC = () => {
  const { t } = useTranslation()
  const router = useRouter()
  const [{ Authorized }, { isAuthorized }] = usePermission(
    settlementAdvanceSection.permissions,
  )
  const { data } = useSettlementCreditLinesQuery({
    skip: !isAuthorized,
  })

  if (!data || data.settlementCreditLines.length === 0) {
    return null
  }

  const creditLineType = data.settlementCreditLines[0].type
  const section = sectionMap[creditLineType]

  const isActive = isPartOfSection(router.pathname, section)

  return (
    <Authorized>
      <Sidenav.Item
        active={isActive}
        anchorComponent={Link}
        href={section.route}
        id={section.label}
        name={section.icon ?? 'ClockNavOutline'}
      >
        <span className="inline-flex items-center">{t(section.label)}</span>
      </Sidenav.Item>
    </Authorized>
  )
}
